import { Icons, Typography, Stack } from '@cast/design-system';

import { HighlightedItem } from './HighlightedItem';

export const PodCountItem = ({
  prev,
  curr,
  label,
}: {
  prev?: number | string | null;
  curr?: number | string | null;
  label?: string;
}) => {
  return (
    <HighlightedItem label={label || ''}>
      <Stack direction="row" alignItems="center" gap={8}>
        <Typography
          variant="P10R"
          color={
            prev === undefined || label === undefined ? 'grey.400' : undefined
          }
        >
          {prev ?? '-'}
        </Typography>

        <Icons.ArrowRight
          css={({ palette }) => ({ color: palette.grey[400] })}
        />
        <Typography
          variant="P10R"
          color={curr === undefined ? 'textSecondary' : undefined}
        >
          {curr ?? '-'}
        </Typography>
      </Stack>
    </HighlightedItem>
  );
};
